import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import moment from 'moment';
import { toast, Zoom } from 'react-toastify';
import { Edit_Donar_List } from '../../api/Donar Api/DonarApi';
import { Show_Slip, UpdateSlipFields } from '../../api/DonationBillApi/DonationCillapi';
import { DialCodeList } from '../../api/DialCodeApi/DialCodeApi';
import { GujaratiDays } from '../../api/GujaratiMonthApi/GujaratiDayApi';
import { GujaratiMonths } from '../../api/GujaratiMonthApi/GujaratiMonthApi';
import TithiDropDown from '../../common/TithiDropDown';
import { ERROR_CODE } from '../../constant';
import { DateFormateChange, isEmpty, maxLengthCheck } from '../../utils/helper';
import LogOut from '../../utils/logout';
import { useNavigate } from 'react-router';
import Select from 'react-select';

const EditDonorModal = ({ isOpen, toggle, slipId, onSuccess }) => {
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [personId, setPersonId] = useState('');

  // Donor form state
  const [donarName, setDonarName] = useState('');
  const [dialCodeDonar, setDialCodeDonar] = useState('+91');
  const [contactNo, setContactNo] = useState('');
  const [donarVillage, setDonarVillage] = useState('');
  const [donarAddress, setDonarAddress] = useState('');
  const [donarPanCard, setDonarPanCard] = useState('');
  const [aadhaarCard, setAadhaarCard] = useState('');
  const [isAksharvashi, setIsAksharvashi] = useState(false);
  const [dodMonth, setDodMonth] = useState('');
  const [dodPaksha, setDodPaksha] = useState('');
  const [dodDate, setDodDate] = useState('');
  const [dialCodeKin, setDialCodeKin] = useState('+91');
  const [contactNoKin, setContactNoKin] = useState('');
  const [dob, setDob] = useState('');

  // Slip form state (no OTP update)
  const [byHand, setByHand] = useState('');
  const [note, setNote] = useState('');
  const [transactionNo, setTransactionNo] = useState('');
  const [bankTransactionDate, setBankTransactionDate] = useState('');
  const [isBankPayment, setIsBankPayment] = useState(false);

  const [dialCodeJson, setDialCodeJson] = useState([]);
  const [gujaratiDate, setGujaratiDate] = useState([]);
  const [gujaratiMonth, setGujaratiMonth] = useState([]);

  useEffect(() => {
    setDialCodeJson(DialCodeList());
    setGujaratiDate(GujaratiDays());
    setGujaratiMonth(GujaratiMonths());
  }, []);

  useEffect(() => {
    if (isOpen && slipId) {
      fetchDonorDetails();
    }
  }, [isOpen, slipId]);

  const fetchDonorDetails = async () => {
    setLoading(true);
    try {
      const { data } = await Show_Slip(slipId);
      if (data.status === 200) {
        const payload = data.payload.data;
        const personDetail = payload?.transactionDetails?.[0]?.accountTransactionDetail?.personDetail;
        
        // Populate Slip details
        setByHand(payload?.byHand || payload?.transactionDetails?.byHand || '');
        setTransactionNo(payload?.transactionNo || '');
        setBankTransactionDate(payload?.bankTransactionDate ? moment(payload.bankTransactionDate).format('YYYY-MM-DD') : '');
        setNote(payload?.transactionDetails?.[0]?.accountTransactionDetail?.note || '');
        setIsBankPayment(payload?.transactionDetails?.[0]?.bankDetail?.type === 2);

        // Populate Donor details
        if (personDetail) {
          setPersonId(personDetail.personId || '');
          setDonarName(personDetail.name || '');
          const mobileParts = (personDetail.mobile || '').split(' ');
          if (mobileParts.length > 1) {
            setDialCodeDonar(mobileParts[0]);
            setContactNo(mobileParts[1]);
          } else {
            setDialCodeDonar('+91');
            setContactNo(personDetail.mobile || '');
          }
          setDonarVillage(personDetail.village || '');
          setDonarAddress(personDetail.address || '');
          setDonarPanCard(personDetail.panCardNo || '');
          setAadhaarCard(personDetail.aadhaarCard || '');
          setIsAksharvashi(personDetail.isDeath || false);

          if (personDetail.isDeath && personDetail.dod) {
            const [m, p, d] = personDetail.dod.split('-');
            setDodMonth(m || '');
            setDodPaksha(p || '');
            setDodDate(d || '');
          } else {
            setDodMonth('');
            setDodPaksha('');
            setDodDate('');
          }

          if (personDetail.kinMobile) {
            const kinParts = personDetail.kinMobile.split(' ');
            setDialCodeKin(kinParts[0] || '+91');
            setContactNoKin(kinParts[1] || '');
          } else {
            setDialCodeKin('+91');
            setContactNoKin('');
          }

          if (personDetail.dob) {
            setDob(moment(DateFormateChange(personDetail.dob)).format('YYYY-MM-DD'));
          } else {
            setDob('');
          }
        }
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message || 'Error loading details', {
        autoClose: 1000,
        transition: Zoom
      });
    } finally {
      setLoading(false);
    }
  };

  const dialCodeOptions = dialCodeJson.map((elem) => ({
    value: elem.code,
    label: elem.country
  }));

  const selectedDialCode = dialCodeOptions.find((opt) => opt.value === dialCodeDonar) || (dialCodeDonar ? { value: dialCodeDonar, label: dialCodeDonar } : null);
  const selectedDialCodeKin = dialCodeOptions.find((opt) => opt.value === dialCodeKin) || (dialCodeKin ? { value: dialCodeKin, label: dialCodeKin } : null);

  const customDialCodeSelectStyles = {
    container: (provided) => ({
      ...provided,
      width: '130px',
      minWidth: '120px',
      marginRight: '6px'
    }),
    control: (provided) => ({
      ...provided,
      minHeight: '38px',
      height: '38px'
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '38px',
      padding: '0 6px'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px'
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '38px'
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
  };

  const handleSaveDetails = async (e) => {
    e.preventDefault();
    if (!donarName.trim()) {
      toast.error('Donor name is required', { autoClose: 1000 });
      return;
    }
    setLoading(true);
    try {
      // 1. Update Donor details
      let donorFormData = isEmpty({
        name: donarName,
        mobile: contactNo ? `${dialCodeDonar} ${contactNo}` : '',
        village: donarVillage,
        panCardNo: donarPanCard,
        aadhaarCard: aadhaarCard,
        address: donarAddress,
        isDeath: isAksharvashi
      });

      if (dob) donorFormData.dob = moment(dob).format('YYYY-MM-DD');
      if (dodMonth && dodPaksha && dodDate) donorFormData.dod = `${dodMonth}-${dodPaksha}-${dodDate}`;
      if (dialCodeKin && contactNoKin) donorFormData.kinMobile = `${dialCodeKin} ${contactNoKin}`;

      await Edit_Donar_List(donorFormData, personId);

      // 2. Update Slip details (without OTP)
      let slipFieldsData = {
        byHand,
        note,
        ...(isBankPayment && { transactionNo, bankTransactionDate })
      };

      await UpdateSlipFields(slipFieldsData, slipId);

      toast.success('Details updated successfully', {
        autoClose: 1000,
        transition: Zoom
      });
      toggle();
      if (onSuccess) onSuccess();
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message || 'Failed to update details', {
        autoClose: 1000,
        transition: Zoom
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <span>Edit Details</span>
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center py-4">Loading details...</div>
        ) : (
          <Form onSubmit={handleSaveDetails}>
            <h6 className="text-primary mb-3">Donor Details</h6>
            <Row>
              <Col md="6 mb-3">
                <Label htmlFor="contactNo">Mobile Number</Label>
                <div className="d-flex align-items-center">
                  <Select
                    options={dialCodeOptions}
                    value={selectedDialCode}
                    onChange={(selected) => setDialCodeDonar(selected ? selected.value : '')}
                    placeholder="Code"
                    isSearchable={true}
                    styles={customDialCodeSelectStyles}
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                  />
                  <Input
                    className="form-control"
                    name="mobile"
                    type="number"
                    placeholder="Mobile Number"
                    id="contactNo"
                    maxLength={10}
                    onInput={maxLengthCheck}
                    value={contactNo}
                    onChange={(e) => setContactNo(e.target.value)}
                  />
                </div>
              </Col>

              <Col md="6 mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <Label htmlFor="donarName">Donor Name *</Label>
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="isAksharvashi"
                      className="form-checkbox"
                      onChange={(e) => setIsAksharvashi(e.target.checked)}
                      checked={isAksharvashi}
                    />
                    <label htmlFor="isAksharvashi" className="px-2 m-0" style={{ cursor: 'pointer', fontSize: '13px' }}>
                      (અક્ષર નિવાસી)
                    </label>
                  </div>
                </div>
                <Input
                  className="form-control"
                  name="name"
                  type="text"
                  placeholder="Donor Name"
                  id="donarName"
                  value={donarName}
                  onChange={(e) => setDonarName(e.target.value)}
                  required
                />
              </Col>

              <Col md="6 mb-3">
                <Label>Kin Mobile Number</Label>
                <div className="d-flex align-items-center">
                  <Select
                    options={dialCodeOptions}
                    value={selectedDialCodeKin}
                    onChange={(selected) => setDialCodeKin(selected ? selected.value : '')}
                    placeholder="Code"
                    isSearchable={true}
                    styles={customDialCodeSelectStyles}
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                  />
                  <Input
                    className="form-control"
                    name="kinMobile"
                    type="number"
                    placeholder="Kin Mobile Number"
                    maxLength={10}
                    onInput={maxLengthCheck}
                    value={contactNoKin}
                    onChange={(e) => setContactNoKin(e.target.value)}
                  />
                </div>
              </Col>

              {isAksharvashi ? (
                <Col md="6 mb-3">
                  <Label>Death Tithi (મૃત્યુ તિથિ)</Label>
                  <TithiDropDown
                    gujaratiDate={gujaratiDate}
                    gujaratiMonth={gujaratiMonth}
                    dodDate={dodDate}
                    dodMonth={dodMonth}
                    dodPaksha={dodPaksha}
                    setDodDate={setDodDate}
                    setDodMonth={setDodMonth}
                    setdodPaksha={setDodPaksha}
                  />
                </Col>
              ) : (
                <Col md="6 mb-3">
                  <Label htmlFor="dob">Date of Birth</Label>
                  <Input
                    className="form-control"
                    type="date"
                    id="dob"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                  />
                </Col>
              )}

              <Col md="6 mb-3">
                <Label htmlFor="donarVillage">Village (ગામ)</Label>
                <Input
                  className="form-control"
                  type="text"
                  id="donarVillage"
                  placeholder="Village"
                  value={donarVillage}
                  onChange={(e) => setDonarVillage(e.target.value)}
                />
              </Col>

              <Col md="6 mb-3">
                <Label htmlFor="donarPanCard">PAN Card No.</Label>
                <Input
                  className="form-control"
                  type="text"
                  id="donarPanCard"
                  placeholder="PAN Card No."
                  value={donarPanCard}
                  onChange={(e) => setDonarPanCard(e.target.value)}
                />
              </Col>

              <Col md="6 mb-3">
                <Label htmlFor="aadhaarCard">Aadhaar Card No.</Label>
                <Input
                  className="form-control"
                  type="text"
                  id="aadhaarCard"
                  placeholder="Aadhaar Card No."
                  value={aadhaarCard}
                  onChange={(e) => setAadhaarCard(e.target.value)}
                />
              </Col>

              <Col md="6 mb-3">
                <Label htmlFor="donarAddress">Address</Label>
                <Input
                  className="form-control"
                  type="text"
                  id="donarAddress"
                  placeholder="Address"
                  value={donarAddress}
                  onChange={(e) => setDonarAddress(e.target.value)}
                />
              </Col>
            </Row>

            <hr className="my-3" />

            <h6 className="text-primary mb-3">Slip Details (શ્લપિ િવગત - No OTP)</h6>
            <Row>
              <Col md="6 mb-3">
                <Label htmlFor="byHand">By Hand (હસ્તે)</Label>
                <Input
                  className="form-control"
                  type="text"
                  id="byHand"
                  placeholder="By Hand (હસ્તે)"
                  value={byHand}
                  onChange={(e) => setByHand(e.target.value)}
                />
              </Col>

              <Col md="6 mb-3">
                <Label htmlFor="note">Note</Label>
                <Input
                  className="form-control"
                  type="text"
                  id="note"
                  placeholder="Note"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </Col>

              {isBankPayment && (
                <>
                  <Col md="6 mb-3">
                    <Label htmlFor="transactionNo">Transaction No.</Label>
                    <Input
                      className="form-control"
                      type="text"
                      id="transactionNo"
                      placeholder="Transaction No."
                      value={transactionNo}
                      onChange={(e) => setTransactionNo(e.target.value)}
                    />
                  </Col>

                  <Col md="6 mb-3">
                    <Label htmlFor="bankTransactionDate">Bank Transaction Date</Label>
                    <Input
                      className="form-control"
                      type="date"
                      id="bankTransactionDate"
                      value={bankTransactionDate}
                      onChange={(e) => setBankTransactionDate(e.target.value)}
                    />
                  </Col>
                </>
              )}
            </Row>
          </Form>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSaveDetails} disabled={loading}>
          Update Details
        </Button>{' '}
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditDonorModal;
